import _regeneratorRuntime from 'babel-runtime/regenerator';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';

export default {
  name: 'RehabReport',
  data: function data() {
    var $el = this;
    return {
      loading: true,
      headers: [],
      properties: [],
      units: [],
      propertySelected: '',
      start_date: moment().startOf('month'),
      end_date: moment().endOf('month')
    };
  },

  props: ['reportId', 'reportType', 'reportTable'],
  mounted: function mounted() {
    var $el = this;
    this.getProperties();
    this.getReport();
  },

  methods: {
    timeRangeChange: function timeRangeChange(_ref) {
      var start_date = _ref.start_date,
          end_date = _ref.end_date;

      this.start_date = start_date;
      this.end_date = end_date;
      this.getReport();
    },
    getProperties: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _ref3, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios.get('/prototype/reporting/get-properties');

              case 2:
                _ref3 = _context.sent;
                data = _ref3.data;

                this.properties = data.map(function (property) {
                  return { id: property.id, name: property.name };
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getProperties() {
        return _ref2.apply(this, arguments);
      }

      return getProperties;
    }(),
    getReport: function getReport() {
      var $el = this;
      $el.loading = true;
      axios.post('/prototype/reporting/get-report', {
        type: $el.reportId,
        table: $el.reportTable,
        start_date: $el.start_date.toDate(),
        end_date: $el.end_date.toDate(),
        property_id: this.propertySelected
      }).then(function (response) {
        if (response.data) {
          $el.headers = response.data.header;
          $el.fields = response.data.field;
          $el.units = response.data.result;
          $el.loading = false;
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    exportReport: function exportReport() {
      Event.$emit('export-report', {
        type: this.reportId,
        table: this.reportTable,
        start_date: this.start_date.toDate(),
        end_date: this.end_date.toDate(),
        property_id: this.propertySelected
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/reports/RehabReport.vue
// module id = 2BpX
// module chunks = 0 1